import request from '@/utils/request'
import service from '@/utils/server'
import service2 from '@/utils/server2'
// 数据统计接口
// cycle_time []Array 第一个开始日期，第二个结束日期 yyyy-mm-dd格式
// filter_by string 填写week / month
// company_id 列表返回
export function getStat(cycle_time, filter_by, company_id) {
  return request({
    url: '/api/Datav/stat?cycle_time=' + cycle_time + '&filter_by=' + filter_by + '&company_id=' + company_id,
    method: 'get'
  })
}

// 登录接口
export function login(data) {
  return service2({
    //url: '/api/User/checkIn',
    url: '/admin/Index/login',
    method: 'post',
    data
  })
}
// 通过imei登录
export function imeilogin(data) {
  return service2({
    url: '/admin/Index/autologin',
    method: 'post',
    data
  })
}

// 设备列表接口
export function getDeviceList(params) {
  return service({
    url: '/admin/Device/index',
    method: 'get',
    params: params
  })
}

//换针设备(详情)
export function getDeviceDetail(data) {
  return service({
    url: '/admin/Device/edit',
    method: 'get',
    params: data
  })
}
//换针设备(开启/关闭)
export function deviceCommand(data) {
  return service({
    url: "/admin/Device/edit",
    method: "post",
    data: data
  })
}

// 换针设备(编辑)
export function setDeviceDetail(data) {
  return service({
    url: '/admin/Device/edit',
    method: 'post',
    data: data
  })
}

//换针记录(列表)
export function changeNeedleHistory(params) {
  return service({
    url: '/admin/Change/index',
    method: 'get',
    params
  })
}

// 换针预警(列表)
export function changeNeedleWarning(params) {
  return service({
    url: '/admin/Alarm/index',
    method: 'get',
    params
  })
}

//针盒数量配置(列表)
export function needleBoxConfig(params) {
  return service({
    url: '/admin/Box/index',
    method: 'get',
    params
  })
}

//缝纫机(列表)
export function sewingMachineList(params) {
  return service({
    url: '/admin/Machine/index',
    method: 'get',
    params
  })
}

//用户(列表)
export function getUserLists(params) {
  return service({
    url: '/admin/user.User/index',
    method: 'get',
    params
  })
}

//用户(新增)
export function addNewUsers(data) {
  return service({
    url: '/admin/user.User/add',
    method: 'post',
    data: data
  })
}

//用户(编辑)
export function editNewUsers(data) {
  return service({
    url: '/admin/user.User/edit',
    method: 'post',
    data: data
  })
}

//用户(删除)
export function delUsers(data) {
  return service({
    url: '/admin/user.User/del',
    method: 'DELETE',
    data: data
  })
}

//生产组(列表)
export function getGrouupLists(params) {
  return service({
    url: '/admin/Team/index',
    method: 'get',
    params
  })
}

//生产组(添加)
export function addGroups(data) {
  return service({
    url: '/admin/Team/add',
    method: 'post',
    data:data
  })
}
//生产组(编辑)
export function editGroups(data) {
  return service({
    url: '/admin/Team/edit',
    method: 'post',
    data:data
  })
}

//生产组(删除)
export function delGroups(data) {
  return service({
    url: '/admin/Team/del',
    method: 'DELETE',
    data: data
  })
}

//缝纫机(添加)
export function addMachines(data) {
  return service({
    url: '/admin/Machine/add',
    method: 'post',
    data:data
  })
}

//缝纫机(编辑)
export function editMachines(data) {
  return service({
    url: '/admin/Machine/edit',
    method: 'post',
    data:data
  })
}

//缝纫机(删除)
export function delMachines(data) {
  return service({
    url: '/admin/Machine/del',
    method: 'DELETE',
    data: data
  })
}

//类型(列表)
export function getProductLists(params) {
  return service({
    // url: '/admin/Product/index',
    url: '/admin/Index/classify_select',
    method: 'get',
    params
  })
}


//针盒添加针记录(添加)
export function addBoxRecords(data) {
  return service({
    url: '/admin/Store/add',
    method: 'post',
    data: data
  })
}
//针盒添加针记录(记录)
export function getBoxRecordLists(params) {
  return service({
    url: '/admin/Store/index',
    method: 'get',
    params
  })
}

//换针记录(列表)
export function reservationLists(params) {
  return service({
    url: '/admin/Reservation/index',
    method: 'get',
    params
  })
}

//产品方案列表
export function getSchemeLists(params) {
  return service({
    url: '/admin/index/scheme_select',
    method: 'get',
    params
  })
}
//绑定方案
export function bindScheme(data) {
  return service({
    url: '/admin/Index/bind_scheme',
    method: 'post',
    data
  })
}
// 获取工厂列表
export function getadminlist(params) {
  return service({
    url: '/admin/auth.Admin/index',
    method: 'get',
    params: {
      ...params
    }
  })
}
// 根据id获取工厂信息
export function getdepartEdit(params) {
  return service({
    url: '/admin/department.department/edit',
    method: 'get',
    params: {
      ...params
    }
  })
}
// 更新工厂信息admin/department.department/edit
export function departEdit(data) {
  return service({
    url: '/admin/department.department/edit',
    method: 'post',
    data: {
      ...data
    }
  })
}
// 根据id获取账号信息
export function getadminEdit(params) {
  return service({
    url: '/admin/auth.Admin/edit',
    method: 'get',
    params: {
      ...params
    }
  })
}
// 更新账号密码
export function adminEdit(params) {
  return service({
    url: '/admin/auth.Admin/edit',
    method: 'post',
    data: {
      ...params
    }
  })
}

// 获取废针列表
export function getwaste(params) {
  return service({
    url: '/admin/Waste/index',
    method: 'get',
    params: {
      ...params
    }
  })
}
// 取出废针
export function takewaste(params) {
  return service({
    url: '/admin/Waste/takeOutWaste',
    method: 'post',
    data: {
      ...params
    }
  })
}
// 获取换针人预警列表
export function getpeoWarnlist(params) {
  return service({
    url: '/admin/index/checkUserIsChangeNeedle',
    method: 'get',
    params
  })
}
// 获取换针人预警配置
export function getpeoZenOption(params) {
  return service({
    url: '/admin/index/getMemberAlarmConfig',
    method: 'get',
    params
  })
}
// 修改换针人预警配置
export function changeZenOption(params) {
  return service({
    url: '/admin/index/updateMemberAlarmConfig',
    method: 'post',
    data: {
      ...params
    }
  })
}
// 部位相关接口
// 增加部位
export function addpart(params) {
  return service({
    url: '/admin/Part/add',
    method: 'post',
    data: {
      ...params
    }
  })
}
// 修改部位信息
export function updatepart(params) {
  return service({
    url: '/admin/Part/update',
    method: 'post',
    data: {
      ...params
    }
  })
}
// 删除部位信息
export function deletepart(params) {
  return service({
    url: '/admin/Part/delete',
    method: 'post',
    data: {
      ...params
    }
  })
}
// 获取部位列表
export function getpartlist(params) {
  return service({
    url: '/admin/Part/index',
    method: 'get',
    params: {
      ...params
    }
  })
}
// 增加款号
export function addStyle(params) {
  return service({
    url: '/admin/Style/add',
    method: 'post',
    data: {
      ...params
    }
  })
}
// 修改款号信息
export function updateStyle(params) {
  return service({
    url: '/admin/Style/update',
    method: 'post',
    data: {
      ...params
    }
  })
}
// 删除款号信息
export function deleteStyle(params) {
  return service({
    url: '/admin/Style/delete',
    method: 'post',
    data: {
      ...params
    }
  })
}
// 获取款号列表
export function getStyleList(params) {
  return service({
    url: '/admin/Style/index',
    method: 'get',
    params: {
      ...params
    }
  })
}

// 上传签单图片
export function postQiandan(params) {
  return service({
    url: '/admin/Change/changeSignSheet',
    method: 'post',
    data: {
      ...params
    }
  })
}

// 修正换针状态
export function changeStatus(params) {
  return service({
    url: '/admin/Change/changeNeedleStatus',
    method: 'post',
    data: {
      ...params
    }
  })
}

// 机器二维码导出
export function exportMachine(params) {
  return service({
    url: '/admin/Machine/exportExcel',
    method: 'post',
    data: {
      ...params
    }
  })
}